const USER_ROLES = {
    ADMIN: 'a',
    FACILITATOR: 'f',
    STUDENT: 's',
    TSC: 't',
    MENTOR: 'm'
}

export default USER_ROLES